// extracted by mini-css-extract-plugin
export default {"description":"style_description__6xaUX","fade-in":"style_fade-in__vqBEY","top":"style_top__-HW5M","image":"style_image__Hy0uj"};